<template lang="pug">
  .b-auth-logo(:class="`auth-logo--${page}-page`")
    Icon(name="logo-vertical")._logo
    template(v-if="page === 'login'")
      span._question Ещё нет аккаунта?
      Btn(dark :to="{ name: 'auth-register' }") Зарегистрироваться
    template(v-if="page === 'register'")
      span._desc Платформа для ведения интерьерных проектов
      Btn(:to="{ name: 'auth-login' }") Войти
</template>

<script>
export default {
  name: 'AuthLogo',
  props: {
    page: {
      type: String,
      required: true,
      validator(value) {
        return ['login', 'register'].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .auth-logo {
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    color: var(--color-white);
    gap: 25px;

    &--login-page {
      padding-right: 50px;
    }
    &--register-page{
      padding: 0 20px;
    }
    &__image {
      max-width: 137px;
      margin: 0 auto;
    }
    &__logo {
      width: 170px;
    }
    &__question {
      color: var(--color-middle-gray);
      font-size: 12px;
      line-height: 16px;
    }
    &__desc {
      color: var(--color-middle-gray);
      font-size: 12px;
      margin: 0 auto;
      max-width: 219px;
    }

    &__link {
      font-size: 12px;
      color: var(--color-accent) !important;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    @media (max-width: 768px) {
      &--login-page &__logo,
      &--login-page &__image,
      &--login-page &__question{
        display: none;
      }
    }
  }
</style>
